import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../assets/images/layouts/banner.png';
import img2 from '../../assets/images/icon/icon-01.png';
import img3 from '../../assets/images/layouts/avt-01.svg';

function Banner(props) {
    return (
        <section className="banner">
            <div className="shape right"></div>
            <div className="container big">
                <div className="row">
                    <div className="col-xl-6 col-md-12">
                        <div className="banner__left">
                            <div className="block-text">
                                <h2 className="heading">
                                    Welcome to <br />
                                    <span className="s1 arlo_tm_animation_text_word">NXTLVL</span> <br />
                                </h2><br /><br />
                                <p className="desc">
                                    NXTLVL is your ultimate gateway to exclusive events, unforgettable nights, and premium nightlife experiences in Orlando.
                                </p>

                                <Link to="/contact" className="action-btn">
                                    <span>Join the Guest List</span>
                                </Link>
                            </div>

                            <div className="pay">
                                <h6>We Partner With</h6>
                                <p>Top clubs, lounges, and venues across the city.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-md-12">
                        <div className="banner__right">
                            <div className="image">
                                <img src={img1} alt="nxtlvl" />
                            </div>

                            <div className="price">
                                <div className="icon">
                                    <img src={img2} alt="nxtlvl" />
                                </div>
                                <div className="content">
                                    <p>THEDANNYMUNOZ</p>
                                    <a href="https://instagram.com/thedannymunoz" target="_blank" rel="noopener noreferrer">
                                        <h5>@thedannymunoz</h5>
                                    </a>
                                </div>
                            </div>

                            <div className="owner">
                                <div className="image">
                                    <img src={img3} alt="nxtlvl" />
                                </div>
                                <div className="content">
                                    <p>NXTLVL NIGHTS</p>
                                    <a href="https://instagram.com/nxtlvlnights" target="_blank" rel="noopener noreferrer">
                                        <h5>@nxtlvlnights</h5>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Banner;